import { render, staticRenderFns } from "./CusPaymentsTableOther.vue?vue&type=template&id=87178396&scoped=true"
import script from "./CusPaymentsTableOther.vue?vue&type=script&lang=js"
export * from "./CusPaymentsTableOther.vue?vue&type=script&lang=js"
import style0 from "./CusPaymentsTableOther.vue?vue&type=style&index=0&id=87178396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87178396",
  null
  
)

export default component.exports